import React from "react"
import { CenteredIcon, Icon } from "Components/AdminConsole/AdminConsole.style"

export const isBusinessActivated = business => {
  return [undefined, true].includes(business?.isActivated)
}

export const isGovernance = business => {
  var valueToReturn = false
  if (business?.isGovernanceBusiness !== undefined) {
    valueToReturn = business.isGovernanceBusiness
  }
  return valueToReturn
}

export const isDocument = business => {
  var valueToReturn = false
  if (business?.useDocumentManagement !== undefined) {
    valueToReturn = business.useDocumentManagement
  }
  return valueToReturn
}

export const isIncidentBusiness = business => {
  var valueToReturn = false
  if (business?.useIncidentManagement !== undefined) {
    valueToReturn = business.useIncidentManagement
  }
  return valueToReturn
}

export const isReferentialsBusiness = business => {
  var valueToReturn = false
  if (business?.useReferentials !== undefined) {
    valueToReturn = business.useReferentials
  }
  return valueToReturn
}

export const isConfigGRCBusiness = business => {
  var valueToReturn = false
  if (business?.useConfigGRC !== undefined) {
    valueToReturn = business.useConfigGRC
  }
  return valueToReturn
}

export const isKpisDashBusiness = business => {
  var valueToReturn = false
  if (business?.useKpisDash !== undefined) {
    valueToReturn = business.useKpisDash
  }
  return valueToReturn
}

export const isUseGEDBusiness = business => {
  var valueToReturn = false
  if (business?.useGED !== undefined) {
    valueToReturn = business.useGED
  }
  return valueToReturn
}

export const isMSFBusiness = business => {
  var valueToReturn = false
  if (business?.useMSF !== undefined) {
    valueToReturn = business.useMSF
  }
  return valueToReturn
}

export const isAuditPlansBusiness = business => {
  var valueToReturn = false
  if (business?.useAuditPlans !== undefined) {
    valueToReturn = business.useAuditPlans
  }
  return valueToReturn
}

export const hasAccessToForm = business => {
  var valueToReturn = false
  if (business?.useForm !== undefined) {
    valueToReturn = business.useForm
  }
  return valueToReturn
}

export const governanceType = Object.freeze({
  MAPPING_RISK: "mappingRisk",
  CONTROL_PLAN: "controlPlan",
})

export const userTableColumns = (trad, functions) => [
  {
    headerName: trad.FIRST_NAME?.toUpperCase(),
    field: "FIRSTNAME",
  },
  {
    headerName: trad.LAST_NAME?.toUpperCase(),
    field: "LASTNAME",
  },
  {
    headerName: trad.EMAIL?.toUpperCase(),
    field: "EMAIL",
  },
  {
    headerName: trad.ACTIONS?.toUpperCase(),
    field: "ACTIVATION",
    maxWidth: 100,
    cellRenderer: ({ data }) => {
      const isUserActive = data?.ACTIVATION === "true"
      const userId = data?.USER_ID
      const businessId = data?.BUSINESS_ID
      return (
        <CenteredIcon>
          {isUserActive ? (
            <Icon
              className="fas fa-user-slash"
              title={trad?.DISABLE_USER}
              onClick={() =>
                functions.updateUserActivation({ userId, businessId, activationStatus: false })
              }
            />
          ) : (
            <Icon
              className="fas fa-user-check"
              title={trad?.ENABLE_USER}
              onClick={() =>
                functions.updateUserActivation({ userId, businessId, activationStatus: true })
              }
            />
          )}
        </CenteredIcon>
      )
    },
  },
]

export const roleTableColumns = (trad, functions) => [
  {
    headerName: trad.ROLE_NAME?.toUpperCase(),
    field: "role",
  },
  {
    headerName: trad.NB_USERS?.toUpperCase(),
    field: "user_counter",
  },
  {
    headerName: trad.ACTIONS?.toUpperCase(),
    field: "id",
    maxWidth: 100,
    cellRenderer: ({ value }) => {
      return (
        <CenteredIcon>
          <Icon
            className="fas fa-pen"
            title={trad?.EDIT_ROLE}
            onClick={() => functions.onOpenEditRoleModal(value)}
          />
          <Icon
            className="fas fa-ban"
            title={trad?.DISABLE_ROLE}
            onClick={() =>
              alert(
                "Fonctionnalité pas encore implémentée, voir avec Laura pour plus d'infos sur la notion de désactivation"
              )
            }
          />
          <Icon
            className="fas fa-trash"
            title={trad?.DELETE_THE_ROLE}
            onClick={() => functions.onTryDeleteRole(value)}
          />
        </CenteredIcon>
      )
    },
  },
]
